import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { AlertPage } from '../modals/alert/alert.page';
import { SelectOrderTypePage } from '../modals/select-order-type/select-order-type.page';
import { environment } from 'src/environments/environment';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';


@Component({
  selector: 'app-restaurant-list',
  templateUrl: './restaurant-list.page.html',
  styleUrls: ['./restaurant-list.page.scss'],
})
export class RestaurantListPage implements OnInit {

  
  public baseURL = environment.BASE_URL;

  public selectfavourite: boolean = false;
  constructor(public inab: InAppBrowser, public appService: AppServiceService, private router: Router, private modalController: ModalController, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      this.selectfavourite = param.selectfavourite === 'true' ? true : false;
    });
  }

  ionViewDidEnter() {
    // if(!this.selectfavourite) this.get_restaurants();

  }



  ionViewWillEnter() {

  }

  ionViewWillLeave() {

  }

  async get_restaurants() {
    await this.appService.clearSelectedRestaurant();
    this.appService.findNearByRestaurants(this.selectfavourite ? '' : 'restaurant-list');
  }

  /**
   * Do things before navigate into restaurant menu page
   * @param restaurant restaurant object
   */
  navigateToRestaurant(restaurant) {
    // console.log('restaurant : ', this.appService.appObject.selectedDeliveryMethod);
    if (this.appService.appObject && this.appService.appObject.selectedDeliveryMethod === 'dine_in' && restaurant.is_bar_mode && restaurant.is_bar_mode === 'true') {
      // console.log('Bar Mode is Enabled');
      // this.appService.fetchAllTablesOfRestaurant(restaurant.id);
      this.appService.openTableSelect(restaurant);
    } else {
      this.router.navigate(['/restaurant', restaurant.slug])
    }
  }

  /**
   * When franchise mode is on, user can mark a resturant as favourite (like default)
   * So when in franchise mode user select mark as favourite this function will trigger 
   * and selected restaurant will be favourite restauarnt till user change
   * @param restaurant selected restaurant object
   */
  async markAsfavourite(restaurant) {
    // console.log('restaurant : ' , restaurant);
    this.appService.appObject.favouriteRestaurant = restaurant;
    this.appService.updateAppObject();

    const modal = await this.modalController.create({
      component: AlertPage,
      cssClass: 'custom-popup',
      componentProps: {
        'type': 'favourite-restaurant'
      }
    });
    await modal.present();

    modal.onDidDismiss().then((dara) => {
      if (!this.appService.appObject.tourEnd && this.appService.appObject.settings?.is_franchise === 'true') {
        this.router.navigate(['home'], { queryParams: { markedFavouriteRestaurant: true } });
      } else {
        this.router.navigate(['home']);
      }
    });
  }

   /**
   * Will return if there is at least one restaurant that has canRequestPostalCodes feature enabled
   * @param restaurantsList restaurants list to check in : if parameter has no value, then assign appObject restaurants list
   * @returns 
   */
   hasPostalCodeRequestableRestaurants(restaurantsList: any[] = null) {
    if (!restaurantsList) restaurantsList = this.appService.appObject.restaurants;
    let foundOne = restaurantsList.find((restaurant) => restaurant.accept_customer_postal_code_requests === 'true' && ((restaurant.currentSelectedPostalCodeStatus
      && (restaurant.currentSelectedPostalCodeStatus.status === 'awaiting_requests' || restaurant.currentSelectedPostalCodeStatus.status === 'customer_requested'))
      || !restaurant.currentPostalStatus));

    return foundOne;
  }

   /**
   * Customer can request selected postal code to not avilable restaurant to activate it too
   * @param restaurant selected restaurant to request selected postal code
   * @param selectedPostalCodeId in single restaurant mode, when user request postal code will send the postal code id too
   */
  requestSelectedPostalCodeForThisBranch(restaurant, selectedPostalCodeId: number = null) {
    // in order to request a postal code, the customer must be registered and logged in
    if (!this.appService.appObject.isAuthed) {
      this.router.navigate(['login'], { queryParams: { requestPostalCode: true } });
      return;
    }

    // find the selected postal code id of the selected restaurant
    // or when its only single restaurant, postal code id will send as a parameter
    let selectedPostalCodeIdOfTheRestaurant = selectedPostalCodeId ? { postalId: selectedPostalCodeId } : this.appService.appObject.postalCodeDetails.status.find((postalCodeStatus) => postalCodeStatus.restaurantId === restaurant.id);
    
    if (selectedPostalCodeIdOfTheRestaurant) {
      // find the whole postal code object from the selected restaurant
      let found = restaurant.postal_code_details_v2.find((postal) => postal.id === selectedPostalCodeIdOfTheRestaurant.postalId);
      if (found) {
        let requestParameters = {
          'restaurants_id': restaurant.id,
          'code': found.code,
          'name': found.name,
          'user_id': this.appService.appObject.userId,
          'postal_code_id': found.id
        }

        this.appService.requestOrVoteForPostalCode(requestParameters).then(async (response: any) => {
          // console.log('response : ', response);
          if (response.status) {
            this.appService.showToast(response.msg, 'success');
          } else {
            this.appService.showToast(response.msg, 'danger');
          }
        }).catch((error) => {
          console.log('error: ', error);
        })
      }
    } else {
      // this means the postal code that selected is not in the selected restaurant list, 
      // but customer can request this postal code coz requesting postal codes are enabled from the restaurant
      let requestParameters = {
        'restaurants_id': restaurant.id,
        'code': this.appService.appObject.postalCodeDetails.code,
        'name': this.appService.appObject.postalCodeDetails.name,
        'user_id': this.appService.appObject.userId,
      }

      this.appService.requestOrVoteForPostalCode(requestParameters).then(async (response: any) => {
        // console.log('response new : ', response);
        if (response.status) {
          this.appService.showToast(response.msg, 'success');
        } else {
          this.appService.showToast(response.msg, 'danger');
        }
      }).catch((error) => {
        console.log('error: ', error);
      })
    }
  }


     /**
     * User will navigate to the social media page
     * @param link social link to navigate 
     */
     public goToSocialLink(link) {


      console.log(link);

      if(link){

      if(this.appService.isBrowser()){
        console.log('web version');
 // Check if the link starts with http:// or https://, if not, add https://
        if (!link.startsWith("http://") && !link.startsWith("https://")) {
          link = "https://" + link;
        }
        // Open the link in a new tab
        console.log(link);
        window.open(link, '_blank');
      }else{
        console.log('!web version');

      if (link) {
        console.log();
        const options: InAppBrowserOptions = {
          location: 'yes',
          closebuttoncaption: 'Close'
        };
        let inab = this.inab.create(link);
      }
    }
  }
    }


clog(obj,text = null){
  console.log(text, obj);
}

}
